var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"shopStartPage"},[_c('side-navigation'),_c('cart-drawer'),_c('inventory-drawer'),_c('scanner-dialog'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }